import classNames from "classnames";
import React, { ButtonHTMLAttributes } from "react";
import { FormattedMessage } from "react-intl";

import style from "./TestAction.module.scss";

export interface TestActionProps extends ButtonHTMLAttributes<HTMLButtonElement> {}

export const TestAction: React.FC<TestActionProps> = ({ className, ...buttonProps }) => (
  <button {...buttonProps} type="button" className={classNames(style.testButton, className)}>
    <FormattedMessage id="actions.test" />
  </button>
);
